'use client'; // Error boundaries must be Client Components

// import { useFormat } from '../helpers/hooks/useFormat';

export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  // Didn't use formatMessage since it seems we don't have access to the I18n provider in error components.
  // Texts can be handled more elegantly when having a CMS.
  // const { formatMessage } = useFormat({ name: 'common' });

  return (
    // global-error must include html and body tags
    <html>
      <body>
        <div className={'container py-112 md:py-249 lg:py-232'}>
          <div className={'flex flex-col items-center text-center lg:items-start lg:text-start'}>
            <h1 className="body-text-2xlarge font-medium">This page isn&apos;t working</h1>
            <p className="body-text-large mt-16">Oh no! We&apos;re experiencing technical difficulties on our end.</p>
            <p className="body-text-large mt-4">Our team is working to solve this issue.</p>
            <p className="body-text-large mt-4">
              Please{' '}
              <button className="font-medium underline" onClick={() => reset()}>
                refresh
              </button>{' '}
              or try again later. We appreciate your patience.
            </p>
          </div>
        </div>
      </body>
    </html>
  );
}
